export default {
  aside: {
    menu: {
      home: 'ホーム',
      creative: {
        name: 'テンプレート',
        playable: 'プレイアブルテンプレート',
        video: '動画テンプレート',
      },
      myproject: {
        name: 'マイプロジェクト',
        record: '録画プロジェクト',
        playable: 'プレイアブルプロジェクト',
        videoAndImage: '画像プロジェクト',
        export: '履歴',
      },
      service: {
        name: 'クリエイティブサービス',
        playable: 'カスタムプレイ可能な広告',
        image: 'カスタム画像＆ビデオ',
      },
      myassets: {
        name: 'アセット',
        asset: 'クリエイティブアセット',
        template: 'テンプレートアセット',
      },
      accountManagement: {
        name: '料金管理',
        billing: {
          usage: 'パッケージの使用',
          materials: 'コスト消費',
        },
        profile: '基本情報',
        reset: 'パスワード',
      },
      settings: {
        name: 'アカウント設定',
        promote: '広告商品',
        record: 'パラメータ辞書',
      },
      poinitManagement: {
        title: 'トラッキング管理',
      },
    },
  },
}
